import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import department from 'src/api/systemManage/department';
import companyInfo from 'src/api/systemManage/companyInfo';

class ModulesAction extends ActionBasic<ModulesState> {
    public getCompanyInfo = async () => {
        const res = await companyInfo.companyInfo(this);
        if(!res.er) {
            this.modulesState.companyInfo = res.res;
            this.setModulesState();
        }
    }

    public departmentQuery = async () => {
        const res = await department.depList(this);
        if(!res.er) {
            this.modulesState.departmentQuery = res.res;
            this.modulesState.treeDate = this.buildTree(res.res);
            this.setModulesState();
        }
    }

    public updateView = (logB, editB?: boolean, setupParent?: string) => {
        this.modulesState.logView = logB;
        this.modulesState.editView = editB;
        this.modulesState.parentId = setupParent;
        if(!this.modulesState.editView) {
            this.modulesState.departmentInfo = {};
        }
        this.setModulesState();
    }

    public createDepartment = async options => {
        const res = await department.createDep(this, options);
        if(!res.er) {
            this.updateView(true);
            this.departmentQuery();
        }
    }

    public updateDepartment = async options => {
        const res = await department.updateDep(this, options);
        if(!res.er) {
            this.updateView(true);
            this.departmentQuery();
        }
    }

    public departmentInfo = async options => {
        const res = await department.departmentInfo(this, options);
        if(!res.er) {
            this.modulesState.departmentInfo = res.res;
            this.updateNoteWord(res.res.description);
            this.setModulesState();
        }
    }

    public deleteDepartment = async options => {
        const res = await department.deleteDep(this, options);
        if(!res.er) {
            this.departmentQuery();
        }
        return res;
    }

    public getDepartmentInfo = async options => {
        const res = await department.departmentInfo(this, options);
        if(!res.er) {
            this.getCompanyInfo();
            this.updateView(true);
            this.setModulesState();
        }
    }

    public saveDepartment = async options => {
        const res = await department.updateDep(this, options);
        if(!res.er) {
            this.getCompanyInfo();
            this.updateView(true);
        }
    }

    public updateNoteWord= (word) => {
        this.modulesState.noteWord = word;
        this.setModulesState();
    }

    public updateDeleteVisable = (b) => {
        this.modulesState.deleteVisible = b;
        this.setModulesState();
    }

    public updateDeleteId = id => {
        this.modulesState.deleteId = id;
        this.setModulesState();
    }

    public updateDeleteName = name => {
        this.modulesState.deleteName = name;
        this.setModulesState();
    }

    public updateRefreshEdit = (b) => {
        this.modulesState.refreshEdit = b;
        this.setModulesState();
    }

    public getParentAvailable = async (id) => {
        const res = await department.matchParentList(this, {departmentId: id});
        if (!res.er) {
            this.modulesState.parentAvailables = res.res;
            this.setModulesState();
            return res.res;
        }
    }

    private buildTree=(data)=>{
        let dataChildList=data.filter((item)=>item.parentDepartmentId);
        let dataRootList=[];
        for(let i=0; i<data.length; i++){
            data[i].children=[];
            if(!data[i].parentDepartmentId){
                dataRootList.push(data[i]);
            }
        }
        let tree = this.loopChildData(dataRootList, dataChildList);
        return tree;
    }

    private loopChildData = (parent, children, insert=false) => {
        for(let i=0; i<parent.length; i++){
            for(let x=0; x<children.length; x++){
                if(parent[i].departmentId === children[x].parentDepartmentId){
                    parent[i].children.push(children[x]);
                }
            }
            if(parent[i].children.length > 0){
                this.loopChildData(parent[i].children, children, true);
            }
        }
        if(insert) {
            return;
        }else{
            return parent;
        }
    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/platform/Organization/Modules.Action.ts